module.exports = __webpack_public_path__ + "static/media/PotatoChipsCover.bd317480.jpg";